module.exports = __webpack_public_path__ + "static/media/4-Y.60ee8f59.mp3";